<template>
	<span>
		<Enter2FA
			ref="enter2FA"
			:callback="codeEntered"
			:is-setup="secondFactorSetupRequired"
			@resend="phoneEntered"
			@setup="reenterPhoneNumber"
		/>
		<Setup2FA ref="setup2FA" :callback="phoneEntered" />
		<b-container>
			<b-row align-v="center" class="vh-100">
				<b-col>
					<b-card style="width:26rem" class="mx-auto bg-none border-none">
						<p class="text-danger">
							{{ errortext }}
						</p>
						<b-form @submit.prevent="submit">
							<b-form-group :label="$t('emailaddress')" label-for="login" label-sr-only>
								<b-form-input
									id="login"
									v-model="form.email"
									:placeholder="$t('emailaddress')"
									type="email"
									required
								/>
							</b-form-group>

							<b-form-group :label="$t('password')" label-for="password" label-sr-only>
								<b-form-input
									id="password"
									v-model="form.password"
									type="password"
									:placeholder="$t('password')"
									required
								/>
							</b-form-group>
							<b-form-group>
								<b-button
									type="submit"
									variant="dark"
									class="text-uppercase w-100 py-2"
								>
									{{ $t("submit") }}
								</b-button>
							</b-form-group>
							<b-form-group>
								<div class="text-center">
									<router-link to="/reset-password">
										{{ $t("loginform.forgot-password") }}
									</router-link>
								</div>
							</b-form-group>
							<b-form-group>
								<div class="text-center">

									<router-link to="/signup">
										{{ $t("loginform.create-an-account") }}
									</router-link>
								</div>
							</b-form-group>
						</b-form>
					</b-card>
				</b-col>
			</b-row>
		</b-container>
	</span>
</template>

<script>
import Enter2FA from '@/views/user/Enter2FA.vue';
import Setup2FA from '@/views/user/Setup2FA.vue';

export default {
	name: 'Signin',
	components: {
		Enter2FA,
		Setup2FA,
	},
	data() {
		return {
			authToken: null,
			secondFactorSetupRequired: false,
			form: {
				email: '',
				password: '',
				phone: '',
			},
			errortext: '',
		};
	},
	mounted() {
		const classList = ['bg-water', 'bg-land', 'bg-sky'];
		const index = ((localStorage.loginBG | 0) + 1) % classList.length;
		this.$store.state.bg_class = classList[index];
		localStorage.loginBG = index;
	},
	methods: {
		submit() {
			this.axios
				.post('/signin', {
					email: this.form.email,
					password: this.form.password,
				})
				.then((signinResponse) => {
					this.errortext = '';
					if (signinResponse.data.secondFactorSetupRequired) {
						this.secondFactorSetupRequired = true;
						this.$refs.setup2FA.show();
					} else {
						this.authToken = signinResponse.data.authToken;
						this.$refs.enter2FA.show();
					}
				})
				.catch(() => {
					this.$refs.enter2FA.hide();
					this.errortext = this.$t('loginform.login-failed');
				});
		},
		phoneEntered(phone) {
			if (phone) {
				this.form.phone = phone;
			}
			this.axios
				.post('/signin', {
					email: this.form.email,
					password: this.form.password,
					secondFactorPhone: this.form.phone,
				})
				.then((signinResponse) => {
					this.authToken = signinResponse.data.authToken;
					this.$refs.setup2FA.hide();
					this.$refs.enter2FA.show();
				})
				.catch(() => {
					this.$refs.setup2FA.hide();
					this.errortext = this.$t('loginform.login-failed');
				});
		},
		codeEntered(code) {
			this.$refs.enter2FA.hide();

			this.axios
				.post('/authenticate', {
					authToken: this.authToken,
					secondFactor: code,
				})
				.then((authenticateResponse) => {
					this.$store.commit('setUser', authenticateResponse.data.user);
					this.$store.commit('setAuthToken', authenticateResponse.data.apiToken);
					// add api token for all future requests
					this.$router.replace('/');
				})
				.catch(() => {
					this.errortext = this.$t('loginform.code-invalid');
				});
		},
		reenterPhoneNumber() {
			this.$refs.enter2FA.clearTimer();
			this.$refs.setup2FA.show();
			this.$refs.enter2FA.hide();
		},
	},
};
</script>

<style lang="scss" scoped>
input::placeholder {
	text-transform: capitalize;
}
</style>
